export const Colors = {
    primary: '#006eb6'
}